import { Injectable } from '@angular/core';

@Injectable()
export class AlertMessagesConfig {
  readonly defaultServerError =
    'We\'re having trouble connecting to our server. Try reloading or checking your internet connection.';

}

export class AlertMessages {
  static readonly defaultServerError =
    'We\'re having trouble connecting to our server. Try reloading or checking your internet connection.';
}
